
// 使用自定义的配置文件发送请求
export function setItemWithExpiry(key, value, ttl) {
    const now = new Date();
    // ttl 是过期时间（单位：毫秒）
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}


export function getItemWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
}

export function removeItem(key) {
    localStorage.removeItem(key);
}



